import { ThemeProps, IconText, MediaQueries } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledSources = styled.div`
  display: block;
  margin-bottom: 0.5rem;

  ${MediaQueries.mbUp} {
    margin-bottom: 1rem;
    border-radius: 16px;
    border: 1px solid #f3f3f3;
    padding: 0 16px 16px 16px;
  }

  --font-weight-lg: ${(props: ThemeProps) => props.theme.sizes.fwBold};
  --font-weight-md: ${(props: ThemeProps) => props.theme.sizes.fwSemiBold};
  --font-weight-sm: ${(props: ThemeProps) => props.theme.sizes.fwRegular};
  &[data-size='lg'] {
    font-size: 18px;
    font-weight: var(--font-weight-lg);
    line-height: 26px;
  }
  &[data-size='md'] {
    font-size: 16px;
    font-weight: var(--font-weight-md);
    line-height: 24px;
  }
  &[data-size='sm'] {
    font-size: 14px;
    font-weight: var(--font-weight-sm);
    line-height: 22px;
  }
`
export const StyledIconText = styled(IconText)``
export const StyledHeading = styled.div`
  padding: 18px 0;
  cursor: pointer;

  ${StyledIconText} {
    color: ${(props: ThemeProps) => props.theme.mbColors.dark};
    font-weight: bold;
    line-height: 1.5;
    ${MediaQueries.mbDown} {
      font-size: 0.7rem;
    }
    ${MediaQueries.mbUp} {
      font-size: 1rem;
    }
    .source-icon {
      width: 1.5rem;
    }
  }
`

export const StyledExpandableContainer = styled.div`
  overflow: hidden;
  height: 0;
  transition: height 0.4s ease;

  .source-wrapper {
    ul {
      padding: 0 18px;
      li {
        &:not(:first-child) {
          padding-top: 1rem;
        }
        list-style-type: circle;

        a {
          color: ${(props: ThemeProps) => props.theme.mbColors.cobalt};
          text-decoration: none;
          p {
            padding-left: 0.75rem;
          }
        }
      }
    }
  }
`
export const StyledSource = styled.p`
  margin-bottom: 0.4rem;
`
